import { useState } from "react";
import { SaleDialog } from "./SaleDialog";
import { RestockDialog } from "./RestockDialog";
import { LossDialog } from "./LossDialog";
import { useSaleManagement } from "./hooks/useSaleManagement";
import { useRestockManagement } from "./hooks/useRestockManagement";
import { useLossManagement } from "./hooks/useLossManagement";
import { useDialogState } from "@/hooks/useDialogState";

interface DialogContainerProps {
  sampleData: any[];
  setSampleData: (data: any[]) => void;
  type: "sale" | "restock" | "loss" | "group-sale";
  isCredit?: boolean;
  selectedItem: any;
  onClose: () => void;
}

export const DialogContainer = ({
  sampleData,
  setSampleData,
  type,
  isCredit = false,
  selectedItem,
  onClose,
}: DialogContainerProps) => {
  const {
    isOpen,
    setIsOpen,
    quantity,
    setQuantity,
    closeDialog,
  } = useDialogState();

  const { handleSaleConfirm } = useSaleManagement({
    sampleData,
    setSampleData,
    selectedItem,
    onClose,
    isCredit
  });

  const { handleRestockConfirm } = useRestockManagement({
    sampleData,
    setSampleData,
    selectedItem,
    onClose
  });

  const { handleLossConfirm } = useLossManagement({
    refetch: () => setSampleData([...sampleData])
  });

  const [groupSaleProducts, setGroupSaleProducts] = useState<any[]>([]);

  const handleGroupSaleConfirm = () => {
    const updatedData = [...sampleData];
    
    groupSaleProducts.forEach(product => {
      const itemIndex = updatedData.findIndex(item => item.id === product.id);
      if (itemIndex !== -1) {
        updatedData[itemIndex] = {
          ...updatedData[itemIndex],
          quantity: updatedData[itemIndex].quantity - product.quantity
        };
      }
    });

    setSampleData(updatedData);
    closeDialog();
    onClose();
  };

  const renderDialog = () => {
    switch (type) {
      case "sale":
      case "group-sale":
        return (
          <SaleDialog
            open={isOpen}
            onOpenChange={setIsOpen}
            selectedItem={selectedItem}
            saleQuantity={quantity}
            onQuantityChange={setQuantity}
            onConfirm={type === "group-sale" ? handleGroupSaleConfirm : () => handleSaleConfirm(parseInt(quantity))}
            isCredit={isCredit}
            onCreditChange={() => {}} // This will be handled by the parent component
            isGroupSale={type === "group-sale"}
            stockItems={sampleData}
            onGroupSaleProductsChange={setGroupSaleProducts}
          />
        );
      case "restock":
        return (
          <RestockDialog
            open={isOpen}
            onOpenChange={setIsOpen}
            selectedItem={selectedItem}
            restockQuantity={quantity}
            onQuantityChange={setQuantity}
            onConfirm={() => handleRestockConfirm(parseInt(quantity))}
          />
        );
      case "loss":
        return (
          <LossDialog
            open={isOpen}
            onOpenChange={setIsOpen}
            lossQuantity={quantity}
            onQuantityChange={setQuantity}
            onConfirm={handleLossConfirm}
            stockItems={sampleData}
          />
        );
      default:
        return null;
    }
  };

  return renderDialog();
};